export const VOLTA_CHAIN_ID = 73799;
export const VOLTA_PUBLIC_RESOLVER_ADDRESS = '0x0a97e07c4Df22e2e31872F20C5BE191D5EFc4680';
export const VOLTA_RESOLVER_V1_ADDRESS = '0xf5EA22c1F799d425356c2aab2004200Ab4490D2b';
export const VOLTA_DOMAIN_NOTIFER_ADDRESS = '0xeea658026d6CDede4380D3aD030beAC911758A93';
export const VOLTA_ENS_REGISTRY_ADDRESS = '0xd7CeF70Ba7efc2035256d828d5287e2D285CD1ac';
export const VOLTA_CLAIM_MANAGER_ADDRESS = '0xC3dD7ED75779b33F5Cfb709E0aB02b71fbFA3210';
export const VOLTA_IDENTITY_MANAGER_ADDRESS = '0x84d0c7284A869213CB047595d34d6044d9a7E14A';
export const VOLTA_STAKING_POOL_FACTORY_ADDRESS = '0x4b2A127680320eD980beAa7aD9b2447B96BC32fC';
export const VOLTA_REWARD_POOL_ADDRESS = '0x6d832DDd386F1dFA53d5b0cACcFF509f95D345Ca';
